import styles from './MpinPage.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import SideBanner from '../../components/side-banner/SideBanner';
import Label from '../../../../constants/Label';
import { loginActions, loginPageActions } from '../../../../stores/_actions';
import Validator from '../../../common/common-functions';
import { Button } from 'semantic-ui-react';
import popClose from 'assets/images/pop-close.svg';
import popup from '../../../components/popup/PopupModel.module.scss';

function MpinPage() {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const jsonData = localStorage.getItem('customer');
  const customer = JSON.parse(jsonData);
  const customerCode = localStorage.getItem('CustomerCode');
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      DeviceID: customer?.DeviceID,
      IDNO: customer?.IDNO,
      MobileNo: customer?.MobileNo,
      MPIN: '',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };
  const [pin, setPin] = useState({
    MPIN: '',
  });
  const [submitted, setSubmitted] = useState(false);
  // const logging = useSelector((state) => state.authentication);
  let logging;
  let openPopup = false;
  useSelector((state) => {
    logging = state.authentication;
  });
  const hidePopup = () => {
    openPopup = false;
    if (logging.user?.statusCode && logging.user?.statusCode == '404') {
      history.push({ pathname: '/register' });
    }
    dispatch(loginPageActions.resetData());
  };

  if (logging.user?.statusCode === '404') {
    openPopup = true;
  }

  const loggingIn = useSelector((state) => state.authentication.loggedIn);

  useEffect(() => {
    localStorage.removeItem('term');
    sessionId ? history.push('/home') : localStorage.removeItem('userProfile');
  }, []);

  const handleChange = (e) => {
    setPin((pin) => ({ ...pin, errorMsg: '' }));
    const { name, value } = e.target;
    if (name == 'one' || name == 'two' || name == 'three' || name == 'four' || name == 'five' || name == 'six') {
      const checkValidMpin = Validator.digitsOnly(value);
      if (!checkValidMpin) {
        errorMsg = 'MPIN field supports only Numerics.';
        setPin((pin) => ({ ...pin, [name]: '' }));
        setPin((pin) => ({ ...pin, errorMsg: errorMsg }));
        return;
      }
    }
    setPin((pin) => ({ ...pin, [name]: value }));
  };

  let errorMsg = '';
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!pin.one || !pin.two || !pin.three || !pin.four || !pin.five || !pin.six) {
      setPin((pin) => ({ ...pin, errorMsg: 'Enter 6 digit MPIN' }));
      return;
    }
    if (pin.one && pin.six) {
      payload.Data['MPIN'] = `${pin.one}${pin.two}${pin.three}${pin.four}${pin.five}${pin.six}`;
      dispatch(loginActions.login(payload));
    }
  };

  const message = 'You have not logged.';
  const forgotRedirection = () => {
    history.push({ pathname: '/forgot-pin', state: { mpin: 'yes' } });
  };

  // start Autofocus with textbox //
  const useMountEffect = (fun) => useEffect(fun, []);
  const UseFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
  };
  const [input1Val, setInput1Val] = useState('');
  const [input2Val, setInput2Val] = useState('');
  const [input3Val, setInput3Val] = useState('');
  const [input4Val, setInput4Val] = useState('');
  const [input5Val, setInput5Val] = useState('');
  const [input6Val, setInput6Val] = useState('');
  const [input1Ref, setInput1Focus] = UseFocus();
  const [input2Ref, setInput2Focus] = UseFocus();
  const [input3Ref, setInput3Focus] = UseFocus();
  const [input4Ref, setInput4Focus] = UseFocus();
  const [input5Ref, setInput5Focus] = UseFocus();
  const [input6Ref, setInput6Focus] = UseFocus();
  const [completeBtnRef, setCompleteFocus] = UseFocus();

  useMountEffect(setInput1Focus);
  // end Autofocus with textbox //

  return (
    <LoadingIndicator>
      <div className={styles.LoginPage}>
        <SideBanner />
        <div className={styles.LoginPage__loginform}>
          <h1>{Label.Mpin.heading}</h1>
          <form name="login" onSubmit={handleSubmit} autoComplete="none">
            <div className={styles.LoginPage__formgroup}>
              <label>{Label.Mpin.formLabelPin}</label>
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="1"
                name="one"
                autoComplete="off"
                value={pin.one}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput1Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput2Focus();
                }}
                ref={input1Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="2"
                name="two"
                autoComplete="off"
                value={pin.two}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput2Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput3Focus();
                }}
                ref={input2Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="3"
                name="three"
                autoComplete="off"
                value={pin.three}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput3Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput4Focus();
                }}
                ref={input3Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="4"
                name="four"
                autoComplete="off"
                value={pin.four}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput4Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput5Focus();
                }}
                ref={input4Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="5"
                name="five"
                autoComplete="off"
                value={pin.five}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput5Val(val);
                  handleChange(e);
                  if (val.length === 1) setInput6Focus();
                }}
                ref={input5Ref}
              />
              <input
                type="password"
                minLength="1"
                maxLength="1"
                tabIndex="6"
                name="six"
                autoComplete="off"
                value={pin.six}
                onChange={(e) => {
                  const val = e.target.value;
                  setInput6Val(val);
                  handleChange(e);
                  if (val.length === 1) setCompleteFocus();
                }}
                ref={input6Ref}
              />
              <div className={styles.formgroup__error}>{pin.errorMsg}</div>
            </div>

            <input
              type="button"
              value="Back"
              className={styles.LoginPage__link}
              onClick={() => {
                history.push('/');
              }}
              style={{ width: '25%', marginRight: '10px' }}
            />
            <input type="submit" value={Label.Mpin.buttonLabel} className={styles.LoginPage__link} style={{ width: '25%', marginRight: '10px' }} />
            {submitted && logging.user?.response == null && logging.user && logging.user?.statusCode !== '404' ? (
              <div className={styles.formgroup__error}>
                <h5>{logging.user?.message}</h5>
              </div>
            ) : (
              ''
            )}
          </form>
          <p className={styles.LoginPage__alrmember}>
            <Link onClick={forgotRedirection}>Forgot MPIN?</Link>
          </p>
        </div>
        {openPopup ? (
          <div className={popup.dialogue}>
            <div className={popup.dialogue__wrap}>
              <img className={popup.dialogue__close} src={popClose} onClick={hidePopup} />
              {logging.user?.statusCode === '404' && (
                <>
                  <p>{logging.user?.message}</p>
                  <br />
                </>
              )}
              <div className={styles.pageLeft__buttonCenter} style={{ textAlign: 'center' }}>
                <Button onClick={hidePopup} className="ui button">
                  {' '}
                  OK
                </Button>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </LoadingIndicator>
  );
}

export { MpinPage };
